import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class FulfillmentLineMetadataTableRowComponent implements IController {

  data: any;

  public metaDataSiteRef: any;

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    const fulfillmentMetaDataSettings = this.splitService.getSiteFulfillmentStepSettings()?.dynamicColumns || [];

    this.metaDataSiteRef = _.find(fulfillmentMetaDataSettings, (s) => {
      return s.key === this.data?.key;
    })
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineMetadataTableRow', {
    bindings: {
      data: '<'
    },
    template: require('./fulfillment-line-metadata-table-row.html').default,
    controller: FulfillmentLineMetadataTableRowComponent
  });
